import { TFunction } from 'i18next';
import { formatCharacterCount } from './eventUtils';

/** Single source of truth for all field max-length constants in the create-event flow. */
export const FIELD_LIMITS = {
  EVENT_TITLE: 255,
  EVENT_DESCRIPTION: 5000,
  SUMMARIZED_DESCRIPTION: 100,
  ROOM: 30,
  LOCATION_NAME: 255,
  LOCATION_NOTES: 500,
  SHIFT_NAME: 128,
  WAIVER_URL: 2000,
  OTHER_PARTNER_NAME: 30,
  GRANT_ID: 30,
  CONTACT_NAME: 128,
  CONTACT_EMAIL: 128,
  CONTACT_PHONE: 32,
} as const;

/**
 * Generates constraintText and errorText props for a Cloudscape FormField with a character limit.
 *
 * @param value - Current field value
 * @param maxLength - Maximum allowed characters (inclusive — value.length === maxLength is valid)
 * @param t - i18next translation function
 * @param constraintKey - i18n key for the constraint label (e.g. 'eventDetailsStep.roomConstraint')
 * @param computedLength - Optional pre-computed length (e.g. from getTextLength for HTML content)
 */
export function getCharLimitProps(
  value: string,
  maxLength: number,
  t: TFunction,
  constraintKey: string,
  computedLength?: number
): { constraintText: string; errorText: string } {
  const len = computedLength ?? value.length;
  return {
    constraintText: `${t(constraintKey, { maxLength })} ${formatCharacterCount(len, maxLength)}`,
    errorText: len > maxLength ? t('error.inputTooLong', { maxLength }) : '',
  };
}
